var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserLandlordRep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.7046,
    cy: 22.5972,
    r: 22.3003,
    fill: "#031CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5228 16.7434C26.5228 18.826 24.8112 20.5181 22.7047 20.5181C20.5982 20.5181 18.8867 18.826 18.8867 16.7434C18.8867 14.6608 20.5982 12.9688 22.7047 12.9688C24.8112 12.9688 26.5228 14.6608 26.5228 16.7434Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7048 22.7578C19.2555 22.7578 16.3327 24.8925 15.1478 27.8862C14.6212 29.2659 15.7271 30.7497 17.228 30.7497H28.1817C29.6826 30.7497 30.7885 29.2659 30.2619 27.8862C29.1033 24.8925 26.1542 22.7578 22.7048 22.7578Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLandlordRep);
export default __webpack_public_path__ + "static/media/User_Landlord_Rep.ce5669787182ce4bbcfd3b3d46d12fc5.svg";
export { ForwardRef as ReactComponent };